export const reCaptcha = (() => {
    var element = document.querySelector('[data-submit-recaptcha]');

    if (element != null) {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            var sitekey = element.getAttribute('data-sitekey');
            grecaptcha.ready(function () {
                grecaptcha.execute(sitekey, { action: 'submit' }).then(function (token) {
                    document.getElementById("token").value = token;
                    document.getElementById("tokenForm").submit();
                });
            });
        });
    }

})();
